import React from 'react';
import './AdminPage.css';
import Schedule from '../../components/Admin/Schedule/Schedule';
import Add from '../../components/Admin/Add/Add';

const AdminPage = () => {
    return (
        <div className="admin-page">
            <Schedule />
            <Add />
            {/* Include other components like Products, NewAppointment, NewProduct, NewCourse here */}
        </div>
    );
}

export default AdminPage;
